import React from 'react';
import classNames from 'classnames';
import FleetManagerLogo from 'assets/images/Fleet-manager-logo.png';

import './AuthPageWrapper.styles.scss';

type AuthPageWrapperProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
};

const AuthPageWrapper: React.FC<AuthPageWrapperProps> = ({
  className,
  title,
  children,
}) => {
  const classes = classNames('auth-page-wrapper', className);

  return (
    <div className={classes}>
      <div className="auth-page-wrapper__content">
        <img className="fm-logo-img" src={FleetManagerLogo} alt="fm-logo-img" />
        {title && <p className="fm-card-title">{title}</p>}
        {children}
      </div>
    </div>
  );
};

export default AuthPageWrapper;
